// src/components/sidebar-widgets/QuickActionsCard.jsx
import React from "react";
import { getFigmaActionIcon } from "../icons/FigmaIcon";
import { openContactCall, openContactEmail } from "../../utils/contactCommunication";
import { Box, Typography, Button } from "@mui/material";
import { Call, Sms, Briefcase } from "iconsax-react";
import {
  quickActionPillButtonSx,
  pillButtonInteractiveSx,
  withPillButtonClassName,
} from "../../utils/pillButtonStyles";
import ProposalIcon from "../icons/ProposalIcon";
import {
  SIDEBAR_WIDGET_CARD_SX,
  SIDEBAR_WIDGET_TITLE_SX,
} from "./sidebarWidgetStyles";

export default function QuickActionsCard({
  onCall,
  onEmail,
  onProposal,
  onAddJob,
  onSchedule,
  onMatchToJob,
  actionItems,
  title = "Quick Actions",
  titleSx,
  actionsContainerSx,
  buttonSx,
  sx = {

  },
}) {
  const actions = Array.isArray(actionItems) && actionItems.length
    ? actionItems
    : [
        {
          key: "call",
          label: "Call",
          onClick: onCall || (() => openContactCall({})),
          icon: <Call size="18" color="#fff" />,
        },
        {
          key: "email",
          label: "Email",
          onClick: onEmail || (() => openContactEmail({})),
          icon: <Sms size="18" color="#fff" />,
        },
        {
          key: "proposal",
          label: "Proposal",
          onClick: onProposal,
          icon: <ProposalIcon />,
        },
        {
          key: "add_job",
          label: "Add Job",
          onClick: onAddJob,
          icon: <Briefcase size="18" color="#fff" />,
        },
      ];

  const baseButtonSx = {
    ...quickActionPillButtonSx,
    fontFamily: "Be Vietnam Pro",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "20px",
    height: 40,
    whiteSpace: "nowrap",
    flex: "0 0 auto",
  };

  return (
    <Box
      className="widget"
      sx={{
        ...SIDEBAR_WIDGET_CARD_SX,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        p: 4,
        gap: 4,
        ...sx,
      }}
    >
      <Typography
        className="heading"
        sx={{
          ...SIDEBAR_WIDGET_TITLE_SX,
          ...titleSx,
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          width: "100%",
          ...actionsContainerSx,
        }}
      >
        {actions.map((action) => (
          <Button
            key={action.key}
            className={withPillButtonClassName()}
            onClick={action.onClick}
            startIcon={action.icon ? (getFigmaActionIcon(action.label) ?? action.icon) : action.icon}
            disabled={Boolean(action.disabled)}
            sx={[pillButtonInteractiveSx, baseButtonSx, buttonSx || {}]}
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
}
